import React, { Component } from 'react'

class EnviarMails extends Component {
    constructor(props){
        super(props);
        this.state = {

        }
    }
    render(){
        return (
            <>
            </>
        )
    }
}

export default EnviarMails